module.exports = __webpack_public_path__ + "media/MRI6.08a8b846.mp3";